import React, { useEffect, useState } from "react";
import { SimpleModal } from "./simpleModal";
import trash from "src/assets/icons/trash.svg";
import { TextField } from "@mui/material";

interface DeleteModalProps {
  open: boolean;
  handleClose: () => void;
  handleDelete: () => void;
  submitTitleButton?: string;
  isLoading: boolean;
  title: string;
  confirmationValue?: string;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  title,
  isLoading = false,
  open,
  handleClose,
  handleDelete,
  submitTitleButton,
  confirmationValue = "",
}) => {
  const [confirmationText, setConfirmationText] = useState("");

  useEffect(() => {
    if (!open) setConfirmationText("");
  }, [open]);

  return (
    <SimpleModal
      open={open}
      onClose={handleClose}
      title={title}
      onSubmit={handleDelete}
      maxWidth="sm"
      isLoading={isLoading}
      submitTitleButton="Delete"
      isDelete={true}
      disableValidationButton={confirmationText !== confirmationValue}
    >
      <div className="flex flex-col justify-center items-center">
        <div className="w-[7vw] h-[7vw] mb-8 rounded-full bg-red-100 flex items-center justify-center">
          <img src={trash} alt="" className="w-[2vw]" />
        </div>
        <p className="text-left mb-3">
          To confirm, type{" "}
          <small className="text-sm font-bold">{`"${confirmationValue}"`}</small>{" "}
          in the box below.
        </p>
        <TextField
          fullWidth
          placeholder=""
          variant="outlined"
          size="small"
          name="confirmationText"
          value={confirmationText}
          onChange={(e) => setConfirmationText(e.target.value)}
          disabled={isLoading}
          sx={{
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: "#ef4444",
                borderWidth: "1px",
              },
            },
          }}
        />
      </div>
    </SimpleModal>
  );
};

export default DeleteModal;
